import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
  locale: localStorage.getItem('lang') ? localStorage.getItem('lang') : process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: localStorage.getItem('lang') ? localStorage.getItem('lang') : process.env.VUE_APP_I18N_LOCALE,
  messages: {},
  silentTranslationWarn: true
})
